export const isImeComposing = ({
  isComposing,
  keyCode,
}: Pick<KeyboardEvent, 'isComposing' | 'keyCode'>) =>
  isComposing || keyCode === 229;
